module.exports = __webpack_public_path__ + "img/ico_fcu_3.1202864b.png";